exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vip-intro-dialog[data-v-dc49817e] .default-content {\n  padding-top: 0;\n}\n.intro-list[data-v-dc49817e] {\n  padding: 0 0.533333rem 1.333333rem;\n  line-height: 1.5;\n  color: #666666;\n  font-size: 0.346667rem;\n}\n.intro-list .intro-title[data-v-dc49817e] {\n  font-size: 0.506667rem;\n  line-height: 0.96rem;\n  color: #333333;\n  font-weight: bold;\n  margin-bottom: 0.333333rem;\n}", ""]);

// exports
